import * as React from 'react'
import { Container, Alert } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import queryString from 'query-string'

function ErrorPage() {
	const { t } = useTranslation()
	const errorObject = queryString.parse(window.location.search)

	return (
		<Container>
			<Alert variant="danger" className="errorPage">
				{t('Authentication error')}
				<br />
				{errorObject.errorMessage}
			</Alert>
		</Container>
	)
}

export default ErrorPage